import { createContext, useState, useEffect } from 'react'
import jwt_decode from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import axios from '../api/axios'

const AuthContext = createContext()

// eslint-disable-next-line react/prop-types
export const AuthContextProvider = ({ children }) => {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        // Fetch user from cookie session 
        console.log('Checking cookie-based session...')
        try {
          const response = await axios.get('admin/profile')
          if (response.data && response.data.status === 'success') {
            const userData = response.data.data
            setUser({
              ...userData,
              role: userData.role,
              user_level: userData.user_level,
              id: userData.id,
            })
            setLoading(false)
            return
          }
        } catch (profileError) {
          console.log('Initial profile check failed, trying token refresh...')
          try {
            const refreshResponse = await axios.post('admin/refresh')
            if (refreshResponse.data && refreshResponse.data.status === 'success') {
              const newToken = refreshResponse.data.token
              if (newToken) {
                const decodedToken = jwt_decode(newToken)
                setUser({
                  ...decodedToken,
                  role: decodedToken.role,
                  user_level: decodedToken.user_level,
                  id: decodedToken.id,
                })
                setLoading(false)
                return
              }
            }
          } catch (refreshError) {
            console.log('Silent token refresh failed:', refreshError.message)
          }
        }
      } catch (error) {
        console.log('No valid cookie session or verification failed:', error.message)
      } finally {
        setLoading(false)
      }
    }

    initializeAuth()
  }, [])

  const login = async (tokenObj) => {
    const decodedToken = jwt_decode(tokenObj.token)
    setUser({
      ...decodedToken,
      role: decodedToken.role,
      user_level: decodedToken.user_level,
      id: decodedToken.id,
    })
  }

  const logout = async () => {
    try {
      await axios.post('admin/logout')
    } catch (error) {
      console.error('Logout API call failed:', error)
    } finally {
      setUser(null)
      navigate('/login')
    }
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
